import React, { useState, useEffect } from 'react'
import ScriptTag from 'react-script-tag'
import Iframe from 'react-iframe'

const StreamPopup = () => {
  return (
    <Iframe url="https://meeting.dps-it.de/testStream"
      width="100%"
      height="100%"
      id="myId"
      className="myClassname"
      display="initial"
      position="relative"
      allow="camera;microphone"
    />
  );
}

export default (StreamPopup)
